import { DataTableActionsV2Component, dataTableActionsV2Template } from './DataTableActionsV2';
import styles from './DataTableActionsV2.styles.scss';
export const chameleonDataTableActionsV2 = DataTableActionsV2Component.compose({
    baseName: 'data-table-actions-v2',
    template: dataTableActionsV2Template,
    styles,
});
